export enum StopStatus {
  Arrived = 'Arribado',
  Delivered = 'Entregado',
  Partial = 'Parcial',
  Pending = 'Pendiente',
  Rejected = 'Rechazado',
  Undelivered = 'No Entregado'
}
